import React from 'react';
import styled from 'styled-components';

const FeedbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FeedbackTitle = styled.span`
  display: block;
  font-size: 7vw;
  margin-bottom: 7.5vh;
  font-family: Inter;
  font-style: normal;
  font-weight: 900;
  line-height: 1.1;
  color: #FFFFFF;
`;

const FeedbackMessage = styled.span`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 4.5vw;
  line-height: 100%;
  color: #FFFFFF;
`;

const FeedbackImgWrapper = styled.div`
  > img, svg {
    display: block;
    height: 9vw;
    margin-bottom: 3vh;
    width: unset;
  }
`;

const FeedBack = ({ message, title, img, styles = {} }) => {
  return (
    <FeedbackWrapper>
      {img && (
        <FeedbackImgWrapper style={styles.img || {}}>
          {img}
        </FeedbackImgWrapper>
      )}
      {title && (
        <FeedbackTitle style={styles.title || {}}>
          {title}
        </FeedbackTitle>
      )}
      <FeedbackMessage style={styles.message || {}}>
        {message}
      </FeedbackMessage>
    </FeedbackWrapper>
  );
};

export default FeedBack;